import { useQuery } from "@apollo/client";
import { AuthGetTalentUserQueryDocument } from "./graphql/AuthGetTalentUserQuery.v5.generated.js";
const useTalentUser = ({ userEmail, organizationSlug })=>{
    const { data, loading } = useQuery(AuthGetTalentUserQueryDocument, {
        context: {
            clientName: 'v5'
        },
        skip: !userEmail || !organizationSlug,
        variables: {
            email: userEmail,
            organizationSlug: organizationSlug
        }
    });
    const hasTalentProduct = !!data?.talent_user;
    const isLeader = Boolean(data?.talent_user?.is_boss) || false;
    const talentModulesCodes = (!loading && data?.talent_user?.modules || []).map((module)=>module.code);
    const talentUser = data?.talent_user;
    return {
        talentUser: {
            job: talentUser?.job ?? '',
            employeeId: talentUser?.employee_id ?? '',
            division: talentUser?.division ?? '',
            bossFullName: talentUser?.boss_full_name ?? '',
            subsidiary: talentUser?.subsidiary ?? '',
            hasTalentProduct,
            isLeader,
            talentModulesCodes,
            talentModules: data?.talent_user?.modules || [],
            talentAdminModules: data?.talent_user?.modules_admin || [],
            roles: data?.talent_user?.talent_roles || [],
            loading,
            company_id_talent: talentUser?.company_id_talent,
            is_boss: talentUser?.is_boss || false
        }
    };
};
const useTalentUser_useTalentUser = useTalentUser;
export default useTalentUser_useTalentUser;
